import { render, staticRenderFns } from "./StatementsTable.vue?vue&type=template&id=f1921928&"
import script from "./StatementsTable.vue?vue&type=script&lang=ts&"
export * from "./StatementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports